import type { CheckboxProps } from '@mantine/core';
import { Checkbox as MantineCheckbox } from '@mantine/core';
import React from 'react';

import styles from './Checkbox.module.css';

export const LBCheckbox = React.forwardRef<
  React.ElementRef<typeof MantineCheckbox>,
  CheckboxProps
>((props, ref) => <MantineCheckbox ref={ref} {...props} classNames={styles} />);
